import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, concatMap, map, withLatestFrom } from 'rxjs/operators';
import { AkkordEntity, AkkordEntityFromBackend } from '../../../entities/akkord/akkord.entity';
import { HttpService } from '../../../services/http.service';
import { AkkordActionTypes } from '../../actions/akkord.action';
import { BaseActionTypes } from '../../actions/base.actions';
import { State } from '../../index';
import { getToken } from '../../selectors/base.selectors';

enum ErrorCodes {
    Load = 'Akkord Abrufen fehlgeschlagen',
}

@Injectable()
export class AkkordEffects {

    GetAkkord$ = createEffect(() => this.actions$.pipe(
        ofType(AkkordActionTypes.LoadAll),
        withLatestFrom(this.store$.select(getToken)),
        concatMap(([action, token]) => {
            const queryString = `
            query {
                akkord {
                    ${AkkordEntity.GqlFields}
                }
            }`;

            return this.gatewayHttpService.graphQl({ query: queryString }, { token, retry: true }).pipe(
                map(res => {
                    return res && res.akkord
                        ? AkkordActionTypes.UpdateAll({
                              Payload: res.akkord.map(e => AkkordEntityFromBackend(e)),
                          })
                        : BaseActionTypes.ErrorAction({ Payload: { ToasterMessage: ErrorCodes.Load } });
                }),
                catchError((err, caught) =>
                    of(
                        BaseActionTypes.ErrorAction({
                            Payload: {
                                ToasterMessage: ErrorCodes.Load,
                                Err: err,
                                Caught: caught,
                            },
                        }),
                    ),
                ),
            );
        }),
    ));

    constructor(private actions$: Actions, private store$: Store<State>, private gatewayHttpService: HttpService) {}
}
